<template>
  <v-card flat class="grey lighten-4" rounded="lg">
    <v-card-text :class="isMobile() ? 'pa-0 mt-2' : ''" >
      <v-data-table
        :items="cliente.mensagens"
        :headers="headers"
        hide-default-footer
        no-data-text="Nenhuma mensagem encontrada"
        disable-sort
        :dense="dense"
      >
        <template v-slot:[`item.tipo`]="{ item }">
          <v-chip dark class="caption" x-small :style="item.classtipo">{{
            item.tipo
          }}</v-chip>
        </template>
        <template v-slot:[`item.bloquear`]="{ item }">
          <span>{{ item.bloquear ? "Sim" : "Não" }}</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    cliente: Object,
    dense: Boolean,
  },
  data: () => ({
    headers: [
      { text: "Mensagem", value: "msg" },
      { text: "Tipo", value: "tipo" },
      {
        text: "Bloqueia emissão do pedido",
        value: "bloquear",
        align: "center",
      },
    ],
  }),
  methods: {
    isMobile(){
      return this.$mq == 'sm'
    }
  }
};
</script>

<style>
</style>